import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import Fab from "@material-ui/core/Fab";
import FlightIcon from "@material-ui/icons/Flight";
import SwipeableViews from "react-swipeable-views";
import CarouselStepperDots from "./carousleStepperDots";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import CarouselStepperDotsFlat from "./Stepper";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { autoPlay } from "react-swipeable-views-utils";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles((theme) => ({
  carouselStepperContainer: {
    background: "transparent",
    margin: "auto",
  },
  carouselItemContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  iconsContainer: {
    position: "absolute",
    width: "100%",
    top: "calc(50% - 55px)",
    display: "flex",
    justifyContent: "space-between",
  },
  icons: {
    position: "relative",
    top: "50%",
    fontSize: 100,
    color: "#000000",
    cursor: "pointer",
  },
  iconRight: {
    right: 20,
    [theme.breakpoints.down("sm")]: {
      right: "2.2%",
    },
  },
  iconLeft: {
    left: 5,
  },
}));

const SwipeableCarousel = ({
  items = [],
  itemsPerCarousel = 1,
  getTestimonialItem,
  showStepper = true,
  deskTopView = true,
  showArrowIcon = false,
  carouselSectionConatiner,
  showArrowParadise = false,
  center = false,
  toorThemeStepper = false,
  title,
  text,
  background = false,
  showFlightIcon=true,
  customStepperPropertys={}
}) => {
  let count = 0;
  let temp_testimonials = [...items];
  let jsxArrayTestimonials = [],
    jsxArrayCarouselItems = [];
  const isMobile = !deskTopView;
  const classes = useStyles();
  const maxSteps = Math.ceil(items.length / itemsPerCarousel);
  const theme = useTheme();

  const Carousel = ({ children }) => {
    const [activeStep, setActiveStep] = React.useState(0);

    const handleStepChange = (step) => {
      if (step < 0 || step >= maxSteps) return;
      setActiveStep(step);
    };
    const stepperSteps = Math.ceil(items.length / itemsPerCarousel);

    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* title and text of toor theme  */}
        {title && (
          <Box width="100%" mb={5}>
            <Typography
              variant="h4"
              style={{
                fontSize: "28px",
                fontWeight: 600,
                color:theme.agentTheme.background.primary_text,
                lineHeight: 1.2,
              }}
            >
              {title}
            </Typography>
            {
              showFlightIcon &&<Box mt={1} display="flex" alignItems="center">
              <FlightIcon
                style={{
                  color: theme?.agentTheme?.primary?.main,
                  fontSize: 22,
                  transform: "rotate(90deg)",
                }}
              />
              <Box
                style={{
                  height: "1px",
                  width: "80px",
                  backgroundColor: theme?.agentTheme?.primary?.main,
                  margin: "-5px",
                }}
              />
            </Box>
            }
            
           <Typography
            variant="body1"
            style={{
              flex: 1,
              mt: 0.5,
              mr: 1, 
              display: "-webkit-box",
              WebkitLineClamp: 2, 
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme?.agentTheme?.text?.body_text_color,
            }}
          >
            {text}
          </Typography>
          </Box>
        )}
          {/* title and text of toor theme end here  */}
        <AutoPlaySwipeableViews
          axis={"x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
          resistance={true}
          {...(toorThemeStepper ? { interval: 7000 } : {})}
          style={carouselSectionConatiner ? { padding: "0 30px" } : {}}
        >
          {children}
        </AutoPlaySwipeableViews>

        {showArrowIcon && (
          <div className={classes.iconsContainer}>
            <Fab
              size="medium"
              style={{
                backgroundColor: theme.agentTheme.background.main,
              }}
              className={`${classes.icons} ${classes.iconLeft}`}
              color="secondary"
              aria-label="left"
              onClick={() => handleStepChange(activeStep - 1)}
              disabled={activeStep == 0}
            >
              <ArrowLeftIcon
                fontSize="large"
                style={{
                  color: theme.palette.getContrastText(
                    theme.agentTheme.background.main
                  ),
                }}
              />
            </Fab>
            <Fab
              size="medium"
              style={{
                backgroundColor: theme.agentTheme.background.main,
              }}
              className={`${classes.icons} ${classes.iconRight}`}
              color="secondary"
              aria-label="right"
              onClick={() => handleStepChange(activeStep + 1)}
              disabled={activeStep === maxSteps - 1}
            >
              <ArrowRightIcon
                fontSize="large"
                style={{
                  color: theme.palette.getContrastText(
                    theme.agentTheme.background.main
                  ),
                }}
              />
            </Fab>
          </div>
        )}
        {showArrowParadise && (
          <div className={classes.iconsContainer}>
            <Fab
              size="medium"
              style={{
                backgroundColor: theme.agentTheme.card.main,
              }}
              className={`${classes.icons} ${classes.iconLeft}`}
              aria-label="left"
              onClick={() => handleStepChange(activeStep - 1)}
              disabled={activeStep == 0}
            >
              <ChevronLeftIcon
                fontSize="large"
                style={{
                  color: theme.agentTheme.card.foreground,
                }}
              />
            </Fab>
            <Fab
              size="medium"
              style={{
                backgroundColor: theme.agentTheme.card.main,
              }}
              className={`${classes.icons} ${classes.iconRight}`}
              aria-label="right"
              onClick={() => handleStepChange(activeStep + 1)}
              disabled={activeStep == maxSteps - 1}
            >
              <ChevronRightIcon
                fontSize="large"
                style={{
                  color: theme.agentTheme.card.foreground,
                }}
              />
            </Fab>
          </div>
        )}

        {showStepper && stepperSteps > 1 && (
          <div
            className={classes.carouselStepperContainer}
            style={{ paddingTop: showArrowParadise && "1rem" }}
          >
            {items.map((item, index) => {
              if (index < maxSteps) {
                return (
                  <CarouselStepperDots
                    activeStep={activeStep == index ? true : false}
                    handleStepChange={handleStepChange}
                    step={index}
                    customStepperPropertys={customStepperPropertys}
                  />
                );
              }
            })}
          </div>
        )}
         {/* toor theme mobile Stepper  */}
        {toorThemeStepper && (
          <div
            className={classes.carouselStepperContainer}
            style={{ paddingTop: "1rem" }}
          >
            {items.map((item, index) => {
              if (index < maxSteps) {
                return (
                  <CarouselStepperDotsFlat
                    activeStep={activeStep == index ? true : false}
                    handleStepChange={handleStepChange}
                    step={index}
                  />
                );
              }
            })}
          </div>
        )}
         {/* toot theme mobile stepper end here  */}
      </div>
    );
  };

  const getMobileTestimonialSections = () => {
    temp_testimonials.forEach((item) => {
      jsxArrayCarouselItems.push(
        <div
          className={classes.carouselItemContainer}
          style={{ justifyContent: center ? "center" : "space-evenly" }}
        >
          {getTestimonialItem(item)}
        </div>
      );
    });
    return jsxArrayCarouselItems;
  };

  const getDesktopTestimonialSections = () => {
    if (temp_testimonials.length <= itemsPerCarousel) {
      count += temp_testimonials.length;
      let temp_data = temp_testimonials.splice(0, temp_testimonials.length);
      temp_data.forEach((item) => {
        jsxArrayTestimonials.push(getTestimonialItem(item));
      });
      jsxArrayCarouselItems.push(
        <div
          className={`${carouselSectionConatiner} ${classes.carouselItemContainer}`}
          style={{ justifyContent: center ? "center" : "space-evenly" }}
        >
          {jsxArrayTestimonials}
        </div>
      );
    } else {
      let temp_data = temp_testimonials.splice(0, itemsPerCarousel);
      temp_data.forEach((item) => {
        jsxArrayTestimonials.push(getTestimonialItem(item));
      });
      jsxArrayCarouselItems.push(
        <div
          className={classes.carouselItemContainer}
          style={{ justifyContent: center ? "center" : "space-evenly" }}
        >
          {jsxArrayTestimonials}
        </div>
      );
      count += itemsPerCarousel;
      jsxArrayTestimonials = [];
      while (temp_testimonials.length > 0) {
        getDesktopTestimonialSections();
      }
    }
    return jsxArrayCarouselItems;
  };

  return (
    <Carousel maxSteps={items.length}>
      {isMobile
        ? getMobileTestimonialSections()
        : getDesktopTestimonialSections()}
    </Carousel>
  );
};

export default SwipeableCarousel;
